import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://frezzer-lleno.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-192">
      <div className="max-w-3xl mx-auto" data-id="element-193">
        <Card className="bg-gradient-to-br from-slate-900 to-slate-800 border-emerald-500/30 text-center relative overflow-hidden" data-id="element-194">
          <div className="absolute -right-10 -top-10 text-emerald-500/10" data-id="element-195">
            <ShieldCheck className="w-64 h-64" data-id="element-196" />
          </div>
          <div className="relative z-10" data-id="element-197">
            <ShieldCheck className="w-16 h-16 text-emerald-400 mx-auto mb-6" data-id="element-198" />
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-199">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="text-xl text-slate-300 mb-6" data-id="element-200">
              Abrís los tomos. Los usás en tu cocina.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-201">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-202" />
              <strong className="text-white" data-id="element-203">devolución del 100%</strong>
              <br data-id="element-204" />
              sin formularios, sin drama.
            </p>
            <p className="text-sm text-emerald-400/80 font-medium" data-id="element-205">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si nunca hice batch cooking?',
    a: 'Sí. El Tomo 1 está diseñado exactamente para eso. Explica el sistema desde cero sin asumir ningún conocimiento previo. Cualquier persona con una cocina estándar puede implementarlo desde el primer domingo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Después de completar el pago recibís un email automático con el enlace de descarga en menos de 5 minutos. Podés verlo en el celular, la tablet o imprimirlo en casa.'
  }, {
    q: '¿Qué lo diferencia de buscar recetas en Google?',
    a: 'Google te da recetas sueltas. El Megapack te da un sistema completo donde cada receta está pensada para congelarse, regenerarse en minutos y formar parte de un ciclo semanal que funciona solo. No es lo mismo tener ingredientes sueltos que tener una cocina organizada.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos sin preguntas. Si no estás satisfecho por cualquier motivo escribís a supportpuntodigital@gmail.com y te devolvemos el 100% del pago. Sin formularios ni condiciones ocultas.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-206">
      <div className="max-w-3xl mx-auto" data-id="element-207">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8 flex items-center justify-center gap-3" data-id="element-208">
          <span className="text-brand-400" data-id="element-209">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-210">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-800 rounded-xl bg-slate-900 overflow-hidden" data-id="element-211">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-212">
                <span className="font-bold text-white pr-8" data-id="element-213">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-brand-400 shrink-0" data-id="element-214" /> : <Plus className="w-5 h-5 text-slate-500 shrink-0" data-id="element-215" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-slate-400" data-id="element-216">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-217">
      <div className="max-w-4xl mx-auto" data-id="element-218">
        <div className="text-center mb-8" data-id="element-219">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-220">
            <Scale className="w-9 h-9 text-amber-400" data-id="element-221" /> ¿CUÁNTO CUESTA NO
            TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-222">
          <table className="w-full text-left border-collapse bg-slate-900 rounded-xl overflow-hidden" data-id="element-223">
            <thead data-id="element-224">
              <tr className="border-b border-slate-800 bg-slate-800/50" data-id="element-225">
                <th className="p-4 text-slate-300 font-medium" data-id="element-226">Sin Megapack</th>
                <th className="p-4 text-red-400 font-bold" data-id="element-227">Costo real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800" data-id="element-228">
              <tr data-id="element-229">
                <td className="p-4 text-slate-400" data-id="element-230">
                  Delivery 3 veces por semana × 52 semanas
                </td>
                <td className="p-4 text-white font-medium" data-id="element-231">
                  +$936.000 ARS al año
                </td>
              </tr>
              <tr data-id="element-232">
                <td className="p-4 text-slate-400" data-id="element-233">
                  20 min de angustia nocturna × 365 días
                </td>
                <td className="p-4 text-white font-medium" data-id="element-234">
                  121 horas de estrés por año
                </td>
              </tr>
              <tr data-id="element-235">
                <td className="p-4 text-slate-400" data-id="element-236">
                  Comida que se vence sin planificación
                </td>
                <td className="p-4 text-white font-medium" data-id="element-237">
                  $15.000-25.000 ARS mensuales tirados
                </td>
              </tr>
              <tr data-id="element-238">
                <td className="p-4 text-slate-400" data-id="element-239">
                  Domingo cocinando sin sistema ni resultados
                </td>
                <td className="p-4 text-white font-medium" data-id="element-240">
                  El mismo agotamiento el próximo lunes
                </td>
              </tr>
              <tr data-id="element-241">
                <td className="p-4 text-slate-400" data-id="element-242">
                  Luncheras armadas a las 7am en caos
                </td>
                <td className="p-4 text-white font-medium" data-id="element-243">
                  5 mañanas de stress por semana
                </td>
              </tr>
              <tr data-id="element-244">
                <td className="p-4 text-slate-400" data-id="element-245">
                  Freezer lleno de cosas sin etiqueta que no sabés qué son
                </td>
                <td className="p-4 text-white font-medium" data-id="element-246">
                  Decisión bloqueada cada noche
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-247">
          <h3 className="text-2xl font-bold text-brand-400 mb-4" data-id="element-248">
            El próximo lunes puede ser diferente.
          </h3>
          <blockquote className="text-xl text-slate-300 italic border-l-4 border-brand-500 pl-6 py-2 text-left" data-id="element-249">
            "La diferencia entre las familias que comen bien durante la semana y
            las que no, no es el dinero ni el tiempo. Es el sistema."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-slate-900 border-brand-500/50 text-center" data-id="element-250">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full font-bold mb-8" data-id="element-251">
            <Clock className="w-5 h-5" data-id="element-252" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-1 gap-6 mb-8 max-w-md mx-auto" data-id="element-253">
            <div className="p-6 border border-slate-700 rounded-xl bg-slate-800/50" data-id="element-254">
              <h4 className="font-bold text-white mb-2" data-id="element-255">
                📘 MEGAPACK FREEZER LLENO
              </h4>
              <p className="text-sm text-slate-400 mb-4" data-id="element-256">
                6 Tomos + 6 Bonos · Todo el año resuelto
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-257">
                <span className="text-slate-500 line-through text-sm" data-id="element-258">
                  49990
                </span>
                <span className="text-3xl font-black text-white" data-id="element-259">$19.990</span>
                <span className="text-sm text-slate-400" data-id="element-260">ARS</span>
              </div>
              <Button className="w-full" variant="outline" onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-261">
                → QUIERO MI MEGAPACK
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-262">
            <span className="flex items-center" data-id="element-263">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-264" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-265">
              <Zap className="w-4 h-4 mr-1 text-amber-400" data-id="element-266" /> Acceso en 5
              minutos
            </span>
            <span className="flex items-center" data-id="element-267">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-400" data-id="element-268" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-269">
              <CreditCard className="w-4 h-4 mr-1 text-blue-400" data-id="element-270" /> Mercado Pago
              | Tarjeta | Transferencia
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-slate-900" data-id="element-271">
      <div className="max-w-4xl mx-auto text-center" data-id="element-272">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-273">
          <span className="text-2xl" data-id="element-274">🧊</span>
          <span className="text-brand-400 font-bold tracking-widest uppercase" data-id="element-275">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-slate-400 mb-4 max-w-2xl mx-auto" data-id="element-276">
          El sistema de alimentación N°1 para familias y trabajadores argentinos
          que quieren comer bien sin improvisar todas las noches.
        </p>
        <p className="text-slate-500 mb-8 italic" data-id="element-277">
          Porque resolver qué comer no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-slate-400 mb-12" data-id="element-278">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-brand-400 transition-colors" data-id="element-279">
            📧 supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-280">
            🌐 www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-slate-600 space-y-2" data-id="element-281">
          <p data-id="element-282">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-283">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-900" data-id="element-284">
          <p className="text-brand-500/50 font-medium italic" data-id="element-285">
            🧊 "El próximo lunes puede ser diferente."
          </p>
          <p className="text-slate-500 text-sm mt-2" data-id="element-286">
            "Un freezer lleno no es solo comida. Es tranquilidad."
          </p>
        </div>
      </div>
    </footer>;
}